const DEFAULT_SITE_ORIGIN = 'https://www.elitesportstours.com';
const LEAGUE_TOKEN = ':league';
const EUROPEAN_SOCCER_LANDING_HEADING = 'European Soccer Travel Packages';
// eslint-disable-next-line @typescript-eslint/no-var-requires
const { teams: mlsTeams = [] } = require('./mls-team-config.json');

const DEFAULT_LEAGUE_ROUTE_CONFIG = {
  publicLandingPath: `/events/${LEAGUE_TOKEN}`,
  legacyLandingPaths: [`/events/${LEAGUE_TOKEN}`],
  publicTeamBasePath: `/events/${LEAGUE_TOKEN}`,
  landingHeading: null,
};

const LEAGUE_SEO_ROUTE_REGISTRY = {
  nba: {
    publicLandingPath: '/nba-travel-packages',
    legacyLandingPaths: ['/events/nba'],
    publicTeamBasePath: '/nba-travel-packages',
    landingHeading: 'NBA Travel Packages',
  },
  mlb: {
    publicLandingPath: '/mlb-travel-packages',
    legacyLandingPaths: ['/events/mlb'],
    publicTeamBasePath: '/mlb-travel-packages',
    landingHeading: 'MLB Travel Packages',
  },
  nfl: {
    publicLandingPath: '/nfl-travel-packages',
    legacyLandingPaths: ['/events/nfl'],
    publicTeamBasePath: '/nfl-travel-packages',
    landingHeading: 'NFL Travel Packages',
  },
  nhl: {
    publicLandingPath: '/nhl-travel-packages',
    legacyLandingPaths: ['/events/nhl'],
    publicTeamBasePath: '/nhl-travel-packages',
    landingHeading: 'NHL Travel Packages',
  },
  mls: {
    publicLandingPath: '/mls-travel-packages',
    legacyLandingPaths: ['/events/mls'],
    publicTeamBasePath: '/mls-travel-packages',
    landingHeading: 'MLS Travel Packages',
  },
  'premier-league': {
    publicLandingPath: '/premier-league-travel-packages',
    legacyLandingPaths: ['/events/premier-league'],
    publicTeamBasePath: '/premier-league-travel-packages',
    landingHeading: 'Premier League Travel Packages',
  },
  'la-liga': {
    publicLandingPath: '/la-liga-travel-packages',
    legacyLandingPaths: ['/events/la-liga'],
    publicTeamBasePath: '/la-liga-travel-packages',
    landingHeading: 'La Liga Travel Packages',
  },
  'serie-a': {
    publicLandingPath: '/serie-a-travel-packages',
    legacyLandingPaths: ['/events/serie-a'],
    publicTeamBasePath: '/serie-a-travel-packages',
    landingHeading: 'Serie A Travel Packages',
  },
  bundesliga: {
    publicLandingPath: '/bundesliga-travel-packages',
    legacyLandingPaths: ['/events/bundesliga'],
    publicTeamBasePath: '/bundesliga-travel-packages',
    landingHeading: 'Bundesliga Travel Packages',
  },
  'ligue-1': {
    publicLandingPath: '/ligue-1-travel-packages',
    legacyLandingPaths: ['/events/ligue-1'],
    publicTeamBasePath: '/ligue-1-travel-packages',
    landingHeading: 'Ligue 1 Travel Packages',
  },
  'uefa-soccer': {
    publicLandingPath: '/uefa-soccer-travel-packages',
    legacyLandingPaths: ['/events/uefa-soccer'],
    publicTeamBasePath: '/uefa-soccer-travel-packages',
    landingHeading: 'UEFA Soccer Travel Packages',
  },
  'mlb-spring-training': {
    publicTeamBasePath: '/events/mlb/spring-training',
  },
  wnba: {
    publicLandingPath: '/wnba-travel-packages',
    legacyLandingPaths: ['/events/wnba'],
    publicTeamBasePath: '/wnba-travel-packages',
    landingHeading: 'WNBA Travel Packages',
  },
  tennis: {
    publicLandingPath: '/tennis-travel-packages',
    legacyLandingPaths: ['/events/tennis'],
    publicTeamBasePath: '/tennis-travel-packages',
    landingHeading: 'Tennis Travel Packages',
  },
  wwe: {
    publicLandingPath: '/wwe-travel-packages',
    legacyLandingPaths: ['/events/wwe'],
    publicTeamBasePath: '/wwe-travel-packages',
    landingHeading: 'WWE Travel Packages',
  },
  pwhl: {
    publicLandingPath: '/pwhl-travel-packages',
    legacyLandingPaths: ['/events/pwhl'],
    publicTeamBasePath: '/pwhl-travel-packages',
    landingHeading: 'PWHL Travel Packages',
  },
  cfl: {
    publicLandingPath: '/cfl-travel-packages',
    legacyLandingPaths: ['/events/cfl'],
    publicTeamBasePath: '/cfl-travel-packages',
    landingHeading: 'CFL Travel Packages',
  },
  rodeo: {
    publicLandingPath: '/rodeo-travel-packages',
    legacyLandingPaths: ['/events/rodeo'],
    publicTeamBasePath: '/rodeo-travel-packages',
    landingHeading: 'Rodeo Travel Packages',
  },
  'world-cup': {
    publicLandingPath: '/world-cup-travel-packages',
    legacyLandingPaths: ['/events/world-cup'],
    publicTeamBasePath: '/world-cup-travel-packages',
    landingHeading: 'World Cup Travel Packages',
  },
  pga: {
    publicLandingPath: '/pga-travel-packages',
    legacyLandingPaths: ['/events/pga'],
    publicTeamBasePath: '/pga-travel-packages',
    landingHeading: 'PGA Tour Golf Travel Packages',
  },
  ufc: {
    publicLandingPath: '/ufc-travel-packages',
    legacyLandingPaths: ['/events/ufc'],
    publicTeamBasePath: '/ufc-travel-packages',
    landingHeading: 'UFC Travel Packages',
  },
  nascar: {
    publicLandingPath: '/nascar-travel-packages',
    legacyLandingPaths: ['/events/nascar'],
    publicTeamBasePath: '/nascar-travel-packages',
    landingHeading: 'NASCAR Travel Packages',
  },
  'formula-1': {
    publicLandingPath: '/formula-1-travel-packages',
    legacyLandingPaths: ['/events/formula-1'],
    publicTeamBasePath: '/formula-1-travel-packages',
    landingHeading: 'Formula 1 Travel Packages',
  },
  'ncaa-mens-basketball': {
    publicLandingPath: '/ncaa-basketball-travel-packages',
    legacyLandingPaths: ['/events/ncaa-mens-basketball'],
    publicTeamBasePath: '/ncaa-basketball-travel-packages',
    landingHeading: 'NCAA Basketball Travel Packages',
  },
  'ncaa-mens-football': {
    publicLandingPath: '/ncaa-football-travel-packages',
    legacyLandingPaths: ['/events/ncaa-mens-football'],
    publicTeamBasePath: '/ncaa-football-travel-packages',
    landingHeading: 'NCAA Football Travel Packages',
  },
  'super-bowl': {
    publicLandingPath: '/super-bowl-travel-packages',
    legacyLandingPaths: ['/events/super-bowl'],
    publicTeamBasePath: '/super-bowl-travel-packages',
    landingHeading: 'Super Bowl Travel Packages',
  },
  'pro-bowl': {
    publicLandingPath: '/pro-bowl-travel-packages',
    legacyLandingPaths: ['/events/pro-bowl'],
    publicTeamBasePath: '/pro-bowl-travel-packages',
    landingHeading: 'Pro Bowl Travel Packages',
  },
};

const MLS_TEAM_SLUG_ALIASES = mlsTeams.reduce((acc, team) => {
  team.legacySlugs.forEach((legacySlug) => {
    acc[legacySlug] = team.canonicalSlug;
  });

  return acc;
}, {});

const LEAGUE_TEAM_SLUG_ALIASES = Object.freeze({
  mlb: {
    'oakland-athletics': 'athletics',
  },
  mls: {
    ...MLS_TEAM_SLUG_ALIASES,
  },
  nhl: {
    'utah-hockey-club': 'utah-mammoth',
  },
  'ncaa-mens-football': {
    virginia: 'virginia-cavaliers',
    'georgia-tech': 'georgia-tech-yellow-jackets',
    duke: 'duke-blue-devils',
    pittsburgh: 'pittsburgh-panthers',
    louisville: 'louisville-cardinals',
    'wake-forest': 'wake-forest-demon-deacons',
    clemson: 'clemson-tigers',
    'florida-state': 'florida-state-seminoles',
    'north-carolina': 'north-carolina-tar-heels',
    'virginia-tech': 'virginia-tech-hokies',
    syracuse: 'syracuse-orange',
    'boston-college': 'boston-college-eagles',
    'texas-tech': 'texas-tech-red-raiders',
    byu: 'byu-cougars',
    utah: 'utah-utes',
    houston: 'houston-cougars',
    arizona: 'arizona-wildcats',
    'arizona-state': 'arizona-state-sun-devils',
    tcu: 'tcu-horned-frogs',
    'iowa-state': 'iowa-state-cyclones',
    cincinnati: 'cincinnati-bearcats',
    'kansas-state': 'kansas-state-wildcats',
    baylor: 'baylor-bears',
    kansas: 'kansas-jayhawks',
    ucf: 'ucf-knights',
    'west-virginia': 'west-virginia-mountaineers',
    colorado: 'colorado-buffaloes',
    'oklahoma-state': 'oklahoma-state-cowboys',
    indiana: 'indiana-hoosiers',
    'ohio-state': 'ohio-state-buckeyes',
    oregon: 'oregon-ducks',
    michigan: 'michigan-wolverines',
    iowa: 'iowa-hawkeyes',
    washington: 'washington-huskies',
    illinois: 'illinois-fighting-illini',
    minnesota: 'minnesota-golden-gophers',
    nebraska: 'nebraska-cornhuskers',
    northwestern: 'northwestern-wildcats',
    'penn-state': 'penn-state-nittany-lions',
    ucla: 'ucla-bruins',
    rutgers: 'rutgers-scarlet-knights',
    wisconsin: 'wisconsin-badgers',
    'michigan-state': 'michigan-state-spartans',
    maryland: 'maryland-terrapins',
    purdue: 'purdue-boilermakers',
    'ole-miss': 'ole-miss-rebels',
    georgia: 'georgia-bulldogs',
    'texas-aandm': 'texas-a-m-aggies',
    'texas-aandm-aggies': 'texas-a-m-aggies',
    'texas-a&m-aggies': 'texas-a-m-aggies',
    'texas-state-bobcats': 'texas-state-san-marcos-bobcats',
    alabama: 'alabama-crimson-tide',
    vanderbilt: 'vanderbilt-commodores',
    texas: 'texas-longhorns',
    oklahoma: 'oklahoma-sooners',
    tennessee: 'tennessee-volunteers',
    missouri: 'missouri-tigers',
    lsu: 'lsu-tigers',
    kentucky: 'kentucky-wildcats',
    florida: 'florida-gators',
    auburn: 'auburn-tigers',
    'mississippi-state': 'mississippi-state-bulldogs',
    'south-carolina': 'south-carolina-gamecocks',
    arkansas: 'arkansas-razorbacks',
  },
  'ncaa-mens-basketball': {
    duke: 'duke-blue-devils',
    virginia: 'virginia-cavaliers',
    'north-carolina': 'north-carolina-tar-heels',
    clemson: 'clemson-tigers',
    louisville: 'louisville-cardinals',
    'florida-state': 'florida-state-seminoles',
    'virginia-tech': 'virginia-tech-hokies',
    'wake-forest': 'wake-forest-demon-deacons',
    syracuse: 'syracuse-orange',
    pittsburgh: 'pittsburgh-panthers',
    'notre-dame': 'notre-dame-fighting-irish',
    'boston-college': 'boston-college-eagles',
    'georgia-tech': 'georgia-tech-yellow-jackets',
    'st-john-s-red-storm': 'st-johns-red-storm',
    arizona: 'arizona-wildcats',
    houston: 'houston-christian-huskies',
    'iowa-state': 'iowa-state-cyclones',
    kansas: 'kansas-jayhawks',
    'texas-tech': 'texas-tech-red-raiders',
    tcu: 'tcu-horned-frogs',
    byu: 'byu-cougars',
    ucf: 'ucf-knights',
    'west-virginia': 'west-virginia-mountaineers',
    cincinnati: 'cincinnati-bearcats',
    colorado: 'colorado-buffaloes',
    'arizona-state': 'arizona-state-sun-devils',
    'oklahoma-state': 'oklahoma-state-cowboys',
    baylor: 'baylor-bears',
    'kansas-state': 'kansas-state-wildcats',
    utah: 'utah-utes',
    michigan: 'michigan-wolverines',
    nebraska: 'nebraska-cornhuskers',
    'michigan-state': 'michigan-state-spartans',
    illinois: 'illinois-fighting-illini',
    wisconsin: 'wisconsin-badgers',
    purdue: 'purdue-boilermakers',
    ucla: 'ucla-bruins',
    'ohio-state': 'ohio-state-buckeyes',
    iowa: 'iowa-hawkeyes',
    indiana: 'indiana-hoosiers',
    minnesota: 'minnesota-golden-gophers',
    washington: 'washington-huskies',
    rutgers: 'rutgers-scarlet-knights',
    northwestern: 'northwestern-state-demons',
    maryland: 'maryland-eastern-shore-hawks',
    'penn-state': 'penn-state-nittany-lions',
    florida: 'florida-gators',
    arkansas: 'arkansas-razorbacks',
    alabama: 'alabama-crimson-tide',
    vanderbilt: 'vanderbilt-commodores',
    tennessee: 'tennessee-volunteers',
    'texas-aandm': 'texas-aandm-aggies',
    georgia: 'georgia-bulldogs',
    kentucky: 'kentucky-wildcats',
    missouri: 'missouri-tigers',
    texas: 'texas-longhorns',
    auburn: 'auburn-tigers',
    oklahoma: 'oklahoma-sooners',
    'mississippi-state': 'mississippi-state-bulldogs',
    'ole-miss': 'ole-miss-rebels',
    'south-carolina': 'south-carolina-gamecocks',
    lsu: 'lsu-tigers',
    'saint-mary-s-gaels': 'saint-marys-gaels',
  },
  pwhl: {
    'boston-fleet': 'boston-fleet-womens-hockey',
    'minnesota-frost': 'minnesota-frost-womens-hockey',
    'montreal-victoire': 'montreal-victoire-womens-hockey',
    'new-york-sirens': 'new-york-sirens-womens-hockey',
    'ottawa-charge': 'ottawa-charge-womens-hockey',
    'toronto-sceptres': 'toronto-sceptres-womens-hockey',
  },
  cfl: {
    'grey-cup': 'cfl-grey-cup',
  },
  rodeo: {
    'calgary-stampede': 'calgary-stampede-rodeo',
    'cheyenne-frontier-days': 'cheyenne-frontier-days-rodeo',
    'pendleton-round-up': 'pendleton-round-up',
    'pbr-team-series-championship': 'pbr-team-series',
    'pbr-unleash-the-beast-tour': 'pbr-unleash-the-beast',
  },
  tennis: {
    'us-open': 'us-open-tennis-championship',
    'indian-wells-masters': 'bnp-paribas-open',
    'miami-open': 'miami-open-tennis',
    'monte-carlo-masters': 'monte-carlo-masters-tennis',
    'madrid-open': 'mutua-madrid-open',
    'atp-finals': 'atp-world-tour-finals',
    'davis-cup': 'davis-cup-tennis',
    'national-bank-open-mens': 'national-bank-open-mens-tennis-canada',
    'national-bank-open-womens': 'national-bank-open-womens-tennis-canada',
  },
  wwe: {
    'survivor-series': 'wwe-survivor-series',
    summerslam: 'wwe-summerslam',
    'money-in-the-bank': 'wwe-money-in-the-bank',
    'saturday-night-main-event': 'wwe-saturday-night-main-event',
  },
  'world-cup': {
    'cote-d-ivoire': 'côte-d-ivoire',
    curacao: 'curaçao',
  },
  pga: {
    'at&t-byron-nelson': 'at-t-byron-nelson-golf-championship',
    'at&t-pebble-beach-pro-am': 'at-t-pebble-beach-national-pro-am',
    'genesis-invitational': 'the-genesis-invitational',
    'honda-classic': 'the-honda-classic',
    'memorial-tournament': 'the-memorial-tournament',
    'players-championship': 'the-players-championship',
    'us-open': 'us-open-golf',
    'zurich-classic-of-new-orleans': 'zurich-classic-of-new-orleans-golf',
  },
});

const LEAGUE_TEAM_PATH_REDIRECTS = Object.freeze({
  mls: mlsTeams.flatMap((team) =>
    team.legacySlugs.map((legacySlug) => ({
      from: legacySlug,
      to: team.canonicalSlug,
    }))
  ),
});

const NFL_SPECIAL_EVENT_SLUGS = Object.freeze(['super-bowl', 'pro-bowl']);
const NFL_SPECIAL_EVENT_SLUG_SET = new Set(NFL_SPECIAL_EVENT_SLUGS);

const normalizeLeagueSlug = (league = '') =>
  String(league).toLowerCase().trim();

const trimTrailingSlash = (pathname = '') => {
  if (!pathname || pathname === '/') {
    return pathname || '/';
  }

  return pathname.endsWith('/') ? pathname.slice(0, -1) : pathname;
};

const normalizePath = (pathname = '/') => {
  if (!pathname) {
    return '/';
  }

  const withLeadingSlash = pathname.startsWith('/') ? pathname : `/${pathname}`;

  return trimTrailingSlash(withLeadingSlash);
};

const normalizePathSegment = (segment = '') =>
  String(segment).replace(/^\/+|\/+$/g, '');

const getCanonicalLeagueTeamSlug = (league = '', teamSlug = '') => {
  const normalizedLeague = normalizeLeagueSlug(league);
  const normalizedTeamSlug = normalizeLeagueSlug(
    normalizePathSegment(teamSlug)
  );

  return (
    LEAGUE_TEAM_SLUG_ALIASES[normalizedLeague]?.[normalizedTeamSlug] ||
    normalizedTeamSlug
  );
};

const applyLeagueTemplate = (template = '', league = '') =>
  template.split(LEAGUE_TOKEN).join(normalizeLeagueSlug(league));

const getLeagueRouteConfig = (league) => {
  const normalizedLeague = normalizeLeagueSlug(league);
  const override = LEAGUE_SEO_ROUTE_REGISTRY[normalizedLeague] || {};
  const internalLandingPath = normalizePath(
    applyLeagueTemplate(
      DEFAULT_LEAGUE_ROUTE_CONFIG.publicLandingPath,
      normalizedLeague
    )
  );
  const publicLandingPath = normalizePath(
    applyLeagueTemplate(
      override.publicLandingPath ||
        DEFAULT_LEAGUE_ROUTE_CONFIG.publicLandingPath,
      normalizedLeague
    )
  );
  const publicTeamBasePath = normalizePath(
    applyLeagueTemplate(
      override.publicTeamBasePath ||
        DEFAULT_LEAGUE_ROUTE_CONFIG.publicTeamBasePath,
      normalizedLeague
    )
  );
  const legacyLandingPaths = Array.from(
    new Set(
      [
        ...(override.legacyLandingPaths ||
          DEFAULT_LEAGUE_ROUTE_CONFIG.legacyLandingPaths),
        internalLandingPath,
      ].map((pathname) =>
        normalizePath(applyLeagueTemplate(pathname, normalizedLeague))
      )
    )
  );

  const internalTeamBasePath = normalizePath(
    applyLeagueTemplate(
      DEFAULT_LEAGUE_ROUTE_CONFIG.publicTeamBasePath,
      normalizedLeague
    )
  );

  return {
    league: normalizedLeague,
    internalLandingPath,
    publicLandingPath,
    legacyLandingPaths,
    publicTeamBasePath,
    internalTeamBasePath,
    landingHeading:
      override.landingHeading || DEFAULT_LEAGUE_ROUTE_CONFIG.landingHeading,
  };
};

const getLegacyLeagueLandingPath = (league) =>
  getLeagueRouteConfig(league).internalLandingPath;

const getLegacyLeagueLandingPaths = (league) =>
  getLeagueRouteConfig(league).legacyLandingPaths;

const getLeagueLandingPath = (league) =>
  normalizeLeagueSlug(league) === 'european-soccer'
    ? '/european-soccer-travel-packages'
    : getLeagueRouteConfig(league).publicLandingPath;

const getLeagueTeamPath = (league, teamSlug = '') => {
  const { publicTeamBasePath } = getLeagueRouteConfig(league);
  const normalizedTeamSlug = getCanonicalLeagueTeamSlug(league, teamSlug);

  return normalizedTeamSlug
    ? `${publicTeamBasePath}/${normalizedTeamSlug}`
    : publicTeamBasePath;
};

const isNflSpecialEventSlug = (slug = '') =>
  NFL_SPECIAL_EVENT_SLUG_SET.has(normalizeLeagueSlug(slug));

const getNflSpecialEventPath = (slug = '') =>
  getLeagueTeamPath('nfl', normalizeLeagueSlug(slug));

const getCanonicalEventPath = ({ league, teamSlug = '' }) => {
  if (teamSlug) {
    return getLeagueTeamPath(league, teamSlug);
  }

  if (isNflSpecialEventSlug(league)) {
    return getNflSpecialEventPath(league);
  }

  return getLeagueLandingPath(league);
};

const getLeagueLandingHeading = (league) =>
  normalizeLeagueSlug(league) === 'european-soccer'
    ? EUROPEAN_SOCCER_LANDING_HEADING
    : getLeagueRouteConfig(league).landingHeading;

const isLeaguePathActive = (pathname, league) => {
  const normalizedPathname = trimTrailingSlash(pathname);
  const { publicLandingPath, legacyLandingPaths, publicTeamBasePath } =
    getLeagueRouteConfig(league);

  if ([publicLandingPath, ...legacyLandingPaths].includes(normalizedPathname)) {
    return true;
  }

  return normalizedPathname.startsWith(
    `${trimTrailingSlash(publicTeamBasePath)}/`
  );
};

const getLeagueRouteEntries = () => {
  const redirects = [];
  const rewrites = [];

  Object.keys(LEAGUE_SEO_ROUTE_REGISTRY).forEach((league) => {
    const {
      internalLandingPath,
      publicLandingPath,
      legacyLandingPaths,
      publicTeamBasePath,
      internalTeamBasePath,
    } = getLeagueRouteConfig(league);

    if (publicLandingPath !== internalLandingPath) {
      rewrites.push({
        source: publicLandingPath,
        destination: internalLandingPath,
      });
    }

    legacyLandingPaths
      .filter((legacyPath) => legacyPath !== publicLandingPath)
      .forEach((legacyPath) => {
        redirects.push({
          source: legacyPath,
          destination: publicLandingPath,
          // 301 Moved Permanently (SEO); do not use permanent:true which maps to 308 in Next.js
          statusCode: 301,
        });
      });

    if (publicTeamBasePath !== internalTeamBasePath) {
      (LEAGUE_TEAM_PATH_REDIRECTS[league] || []).forEach(({ from, to }) => {
        redirects.push({
          source: `${internalTeamBasePath}/${from}`,
          destination: `${publicTeamBasePath}/${to}`,
          statusCode: 301,
        });
        redirects.push({
          source: `${publicTeamBasePath}/${from}`,
          destination: `${publicTeamBasePath}/${to}`,
          statusCode: 301,
        });
      });

      rewrites.push({
        source: `${publicTeamBasePath}/:path*`,
        destination: `${internalTeamBasePath}/:path*`,
      });

      redirects.push({
        source:
          league === 'mlb'
            ? `${internalTeamBasePath}/:path((?!spring-training(?:/|$)).*)`
            : `${internalTeamBasePath}/:path*`,
        destination: `${publicTeamBasePath}/:path*`,
        statusCode: 301,
      });
    }
  });

  return {
    redirects,
    rewrites,
  };
};

const normalizeLeagueLandingUrl = (url, league) => {
  if (!url) {
    return url;
  }

  const { publicLandingPath, legacyLandingPaths } =
    getLeagueRouteConfig(league);
  const isAbsoluteUrl = /^https?:\/\//i.test(url);
  const parsedUrl = isAbsoluteUrl
    ? new URL(url)
    : url.startsWith('/')
      ? new URL(url, DEFAULT_SITE_ORIGIN)
      : null;

  if (!parsedUrl) {
    return url;
  }

  if (isAbsoluteUrl && parsedUrl.origin !== DEFAULT_SITE_ORIGIN) {
    return url;
  }

  const normalizedPathname = trimTrailingSlash(parsedUrl.pathname);
  const matchesLegacyLandingPath =
    legacyLandingPaths.includes(normalizedPathname);

  if (!matchesLegacyLandingPath && normalizedPathname !== publicLandingPath) {
    return url;
  }

  const normalizedUrl = `${publicLandingPath}${parsedUrl.search}${parsedUrl.hash}`;

  return isAbsoluteUrl
    ? `${DEFAULT_SITE_ORIGIN}${normalizedUrl}`
    : normalizedUrl;
};

module.exports = {
  DEFAULT_LEAGUE_ROUTE_CONFIG,
  LEAGUE_SEO_ROUTE_REGISTRY,
  NFL_SPECIAL_EVENT_SLUGS,
  getCanonicalEventPath,
  getCanonicalLeagueTeamSlug,
  getLeagueLandingHeading,
  getLeagueLandingPath,
  getLeagueRouteConfig,
  getLeagueRouteEntries,
  getLeagueTeamPath,
  getLegacyLeagueLandingPath,
  getLegacyLeagueLandingPaths,
  getNflSpecialEventPath,
  isNflSpecialEventSlug,
  isLeaguePathActive,
  normalizeLeagueLandingUrl,
};
